import { StudentAttendanceDetailDTO, StudentProgressRowDTO, StudentProgressSummaryDTO } from "../../../../models/StudentProgressDTO";

export type ProgressFilter =
	| "todos"
	| "rotativos"
	| "compuestos"
	| "conAlerta"
	| "sinAsistir"
	| "faltoSemana"
	| "horasDeMas"
	| "cubierto"
	| "porGraduarse"
	| "bajoMinimo";

export interface ProgressChip {
	llave: ProgressFilter;
	texto: string;
	cuenta: number;
}

/** Horario distinto dentro del curso/periodo elegido, ya con el nombre en am/pm. */
export interface ScheduleOption {
	id: number;
	name: string;
	level?: string;
	period?: string;
}

/** Nombre del profesor tal como se muestra; SIN_PROFESOR agrupa las filas con mentorName null. */
export const SIN_PROFESOR = "Sin profesor";

export interface StructuredFilters {
	mentor: string;
	course: string;
	period: string;
	scheduleIds: number[];
}

export interface StructuredFilterOptions {
	mentors: string[];
	courses: string[];
	periods: string[];
	schedules: ScheduleOption[];
}

export interface AttendanceModalState {
	row: StudentProgressRowDTO | null;
	loading: boolean;
	detail: StudentAttendanceDetailDTO | null;
	error: string | null;
}

/** Mensaje sugerido de WhatsApp elegido para una fila: el envío sale por WappChat, no por el servidor. */
export interface WhatsappModalState {
	row: StudentProgressRowDTO | null;
	template: string;
}

export interface StudentProgressViewProps {
	sectionLoaded: boolean;
	campusName: string;
	idleLocked: boolean;

	summary: StudentProgressSummaryDTO;
	chips: ProgressChip[];
	filter: ProgressFilter;
	onFilter: (filter: ProgressFilter) => void;

	includeInactive: boolean;
	onToggleInactive: () => void;
	includeInactiveStudents: boolean;
	onToggleInactiveStudents: () => void;

	structured: StructuredFilters;
	structuredOptions: StructuredFilterOptions;
	onMentor: (mentor: string) => void;
	onCourse: (course: string) => void;
	onPeriod: (period: string) => void;
	onToggleSchedule: (scheduleId: number) => void;
	onClearStructured: () => void;

	search: string;
	onSearch: (value: string) => void;

	rows: StudentProgressRowDTO[];
	totalFiltered: number;
	page: number;
	pageCount: number;
	pageSize: number;
	onPage: (page: number) => void;

	onExport: () => void;

	gradesRow: StudentProgressRowDTO | null;
	onOpenGrades: (row: StudentProgressRowDTO) => void;
	onCloseGrades: () => void;

	onOpenProfile: (row: StudentProgressRowDTO) => void;

	attendance: AttendanceModalState;
	onOpenAttendances: (row: StudentProgressRowDTO) => void;
	onCloseAttendances: () => void;

	whatsapp: WhatsappModalState;
	onOpenWhatsapp: (row: StudentProgressRowDTO) => void;
	onCloseWhatsapp: () => void;
	onPickTemplate: (key: string) => void;

	/* FASE 3: pestaña Por reponer. */
	campusId: number;
	currencyCode: string;
	tab: ProgressTab;
	onTab: (tab: ProgressTab) => void;
	/** Sesiones por reponer abiertas en las filas cargadas. */
	recoveryOpen: number;
	onRecoveriesChanged: () => void;
}

export type ProgressTab = "progreso" | "reponer";
